import { render, staticRenderFns } from "./TheCourtRulingsModal.vue?vue&type=template&id=5d8a06c8&"
import script from "./TheCourtRulingsModal.vue?vue&type=script&lang=js&"
export * from "./TheCourtRulingsModal.vue?vue&type=script&lang=js&"
import style0 from "./TheCourtRulingsModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports